import { currentWatchedPage } from './js/header-library';
import { currentQueuePage } from './js/header-library';
import './js/library-watched-btn';
import './js/modal-footer';
import './js/modal-btns';
import './js/scrolling';
import { handlWatched } from './js/library-watched-btn';
import './js/open-close-modal';

currentWatchedPage();
handlWatched('watchedList');
